import { Component } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FilingsService } from './filings/filings.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'insider-trading-firebase';
  constructor(
    private afAuth: AngularFireAuth,
    private filingsService: FilingsService
  ) {
    this.afAuth.signOut();
    this.filingsService.init();
    // setTimeout(() => {
    //   console.log('sign');
    //   this.signIn();
    // }, 10000);
  }

  // signIn() {
  //   this.afAuth.signInAnonymously()
  //     .then((result) => {
  //       console.log('signed in: ', result);
  //       this.filingsService.init();
  //     }).catch((error) => {
  //       console.log('error signing in anonymously: ', error);
  //     });
  // }
}
